import {Layer} from "@/includes/parse_psd_data/psd-types/layer";

export class Shape extends Layer {}
